import React, { Component } from "react";
import { Divider, Typography } from "@material-ui/core";
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { LoadingCard, SaspButton, CopyrightWidget } from "../components";
import { getQuizzesResults, trackPage } from "../actions";
import { deviceData, createMarkup, getThisYear } from "../common";
import { Link } from "react-router-dom/cjs/react-router-dom";


class QuizResultScreen extends Component {
    state = {
        show: false,
        loadingtext: ["Loading Quiz Results..."],
        title: "Quiz Results",
        results: [],
        rendered: false
    }

    componentDidMount = async () => {
        const { instance, deckid } = this.props.location.state;
        const { mcid, key } = this.props.auth_feedback;
        let data = { instance, deckid, mcid, key }
        let tracking = deviceData(this.props.location, 'navigate');

        tracking.action = 'navigate';
        tracking.detail = instance
        tracking.detailvar = 'Quiz Instance';

        let tobj = {
            mcid: mcid,
            key: key,
            instance: instance,
            deckid: deckid,
            tracking: tracking
        }

        await this.props.trackPage(tracking);
        return this.props.getQuizzesResults(data, tracking);

        if (
            typeof this.props.quizResult === 'undefined' || 
            this.props.quizResult === null || 
            Array.isArray(this.props.quizResult) === true
        ) {
            await this.props.getQuizzesResults(data, tracking);
            return null;
        } else if (this.props.quizResult.instance !== instance) {
            await this.props.getQuizzesResults(data, tracking);
            return null;
        } else {
            // await this.props.getQuizzesResults(data, tracking);
            return this.setState({ ...this.state, results: this.props.quizResult});
        }
        
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.quizResult !== this.props.quizResult) {
            return this.setState({ ...this.state, results: this.props.quizResult, rendered: true })
        }

        if (prevProps.quizResult === this.props.quizResult && !this.state.rendered) {
            return this.setState({ ...this.state, results: this.props.quizResult, rendered: true })
        }

        if (prevState.results !== this.state.results) {
            return this.setState({ ...this.state, show: true, title: `Quiz Results - ${this.state.results.title}` })
        }
    }

    componentWillUnmount = async () => {
        this.setState({ show: false, results: [], rendered: false })
    }  

    render() {
        try {
            if (!this.state.show) {
                return (
                    <LoadingCard textarray={this.state.loadingtext} /> 
                )
            } else {
                const retakeObj = {
                    pathname: '/quizScreen',
                    deckid: this.state.results.deckid,
                    deckID: this.state.results.deckid,
                    gameMode: this.props.location.state.gamemode,
                    gamemode: this.props.location.state.gamemode
                }
                const reviewObj = {
                    pathname: '/quizListScreen',
                    deckid: this.state.results.deckid,
                    deckID: this.state.results.deckid,
                    gameMode: this.props.location.state.gamemode,
                    gamemode: this.props.location.state.gamemode
                }
                return (
                    <div className=" aua-overflow" id="QuestionDiv">
                        <Typography className="homeDividerText">{this.state.results.title}</Typography>
                        <p><small>{this.state.results.subtitle} | Completed on: {this.state.results.completedON}</small></p>
                        <div className="question-container" >
                            <section className="margin-bottom-8">
                                <p className="margin-bottom-8">Your Score: {this.state.results.percentage}%</p>
                                <p className="margin-bottom-8">You answered {this.state.results.correct} out of {this.state.results.total} questions correctly.</p>    
                            </section>

                            <section>
                                <p className="margin-bottom-16">Review your incorrect answers and try again to improve your score!</p>
                                <div className="flex-row-between margin-bottom-16 width100">
                                    <SaspButton className="aua-btn btn-dark-blue">
                                        <Link to={retakeObj} >
                                            Take Quiz
                                        </Link>
                                    </SaspButton>

                                    <SaspButton className="aua-btn btn-blue">
                                        <Link to={reviewObj} >
                                            Review Topic
                                        </Link>
                                    </SaspButton> 

                                    <SaspButton className="aua-btn btn-blue-on-white">
                                        <Link to={
                                            {
                                                pathname: '/home'
                                            }} 
                                        >
                                            Return Home
                                        </Link>
                                    </SaspButton>
                                </div>
                            </section> 

                            <Divider className="margin-bottom-16" />

                            <section>
                                {this.state.results.data.map((question, index) => {
                                    let resclass = '';
                                    let restext = 'Correct';
                                    if (question.answercorrect === 0) {
                                        resclass = 'text-red';
                                        restext = 'Incorrect';
                                    }
                                
                                    return (
                                        <div key={index} className="margin-bottom-16 review-quiz-card">
                                            <div className="margin-bottom-8 text-blue"><strong>SASP {question.QYear} Question {question.QNumber} </strong></div>
                                            
                                            <div dangerouslySetInnerHTML={createMarkup(question.QText)} />

                                            <dl className="margin-bottom-4">
                                                <dt><strong>Your Answer ({restext}):</strong></dt>
                                                <dd className={resclass}>{question.OptionLetter ? question.OptionLetter : 'N/A'}: {question.OptionText ? question.OptionText : 'N/A'}</dd>
                                                <dt><strong>Correct Answer:</strong></dt>
                                                <dd>{question.CorrectOptionLetter ? question.CorrectOptionLetter : 'N/A'}: {question.CorrectOptionText ? question.CorrectOptionText : 'N/A'}</dd>
                                            </dl>
                                        </div>
                                    )
                                })}
                            </section>

                            <Divider className="margin-bottom-16" />
                            
                            <section>
                                <p className="margin-bottom-16 text-left">Review your incorrect answers and try again to improve your score!</p>
                                <div className="flex-row-between margin-bottom-16 width100">
                                    <SaspButton className="aua-btn btn-dark-blue">
                                        <Link to={retakeObj} >
                                            Take Quiz
                                        </Link>
                                    </SaspButton>

                                    <SaspButton className="aua-btn btn-blue">
                                        <Link to={reviewObj} >
                                            Review Topic
                                        </Link>
                                    </SaspButton> 

                                    <SaspButton className="aua-btn btn-blue-on-white">
                                        <Link to={
                                            {
                                                pathname: '/home'
                                            }} 
                                        >
                                            Return Home
                                        </Link>
                                    </SaspButton>
                                </div>
                            </section> 

                            <Divider className="margin-bottom-16" />
                            
                            <CopyrightWidget 
                                style={{width: "auto;"}}
                                year={getThisYear()}
                                textAlign={'center'}
                                className="margin-top-8 padding-top-8 padding-bottom-24"
                            />
                        </div>
                    </div>
                )
            }
        } catch (err) {
            console.log(`QuizResultScreen render error: `, err);
            return <Redirect to="/home" /> 
        }
    }
}

const mapStateToProps = state => {
    const { quizList, quizListAll, quizResult } = state.decks;
    const { auth_feedback } = state.auth;

    return {
        quizResult,
        quizList,
        quizListAll,
        auth_feedback
    }
}

export default connect(
    mapStateToProps, 
    { getQuizzesResults, trackPage }
)(QuizResultScreen);